import EventEmitter from 'eventemitter3';

import Dialog from 'src/interfaces/dialog';

const dialogEventEmitter = new EventEmitter();

const onAddDialog = (listener: (dialog: Dialog) => void) => {
  dialogEventEmitter.on('add-dialog', listener);
};

const offAddDialog = (listener: (dialog: Dialog) => void) => {
  dialogEventEmitter.off('add-dialog', listener);
};

const addDialog = (dialog: Dialog) => {
  dialogEventEmitter.emit('add-dialog', dialog);
};

const onPopById = (listener: (id: string) => void) => {
  dialogEventEmitter.on('pop-by-id', listener);
};

const offPopById = (listener: (id: string) => void) => {
  dialogEventEmitter.off('pop-by-id', listener);
};

const popById = (id: string) => {
  dialogEventEmitter.emit('pop-by-id', id);
};

export default {
  onAddDialog,
  offAddDialog,
  addDialog,
  onPopById,
  offPopById,
  popById,
};
